import { isC3Experience } from "../../../shared/util/C3Utils";
define((require) => {
    "use strict";

    const Enum    = require("shared/util/Enum");
    const UrlUtil = require("shared/util/UrlUtil");
    const Configuration = require("shared/services/Configuration");

    const sources = {
        CREATOR: {
            name: "creator",
            title: "Creator Images",
            getUrl: (url, size, cloudinaryProvider) => {
                const extension = UrlUtil.getFileExtension(url) || "";
                const extensionFinalName = extension ? `.${extension}` : "";
                const urlNoExtension = extension ? url.replace(`.${extension}`, "") : url;

                // Check if mandatory Cloudinary Provider enabled and exists
                if (cloudinaryProvider) {
                    return `${Configuration.cloudinaryProviderUrl}/f_auto,q_auto/${UrlUtil.getFileNameWithExtension(url)}`;
                }

                if (!size) {
                    // Optimized image url are only used for Creator and in the case there are no resize information defined
                    if (isC3Experience())
                        return `${urlNoExtension}${extensionFinalName}`;

                    return `${urlNoExtension}-optimized${extensionFinalName}`;
                }

                // Creator resized images
                return `${urlNoExtension}_${size.width}x${size.height}${extensionFinalName}`;
            },
            getCropUrl: (url, crop) => `${Configuration.cloudinaryProviderUrl}/w_${crop.width},h_${crop.height},x_${crop.x},y_${crop.y},c_crop,f_auto,q_auto/${UrlUtil.getFileNameWithExtension(url)}`
        },
        SCENE7: {
            name: "Scene7Integration",
            title: "Scene7 Images",
            getUrl: (url, size) => `${url}?size=${size.width},${size.height}`
        }
    };

    return Enum.create("ImageLibrarySourceEnum", "name", sources);
});



// WEBPACK FOOTER //
// ./src/shared/data/images/ImageLibrarySourceEnum.js